import { useApiQuery } from 'src/infrastructure/rest-api/useApi';
import { useChainId } from '../chain';

export const usePhaseoutProfiles = () => {
    const chainId = useChainId();

    return useApiQuery('/api/phaseoutprofile/chains/{chainId}', 'get', {
        path: {
            chainId: chainId,
        },
        enabled: typeof chainId === 'number',
    });
};
